import { createActionGroup, props } from '@ngrx/store';
import { ErrorModel } from '@era/app';
import { MdmAvailableOsUpdate } from './mdm-available-os-updates.state';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const MdmAvailableOsUpdatesResolverActions = createActionGroup({
  source: 'MdmAvailableOsUpdates Resolver',
  events: {
    'Available OS Updates Requested': props<{ udid: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const MdmAvailableOsUpdatesApiActions = createActionGroup({
  source: 'MdmAvailableOsUpdates API',
  events: {
    'Available OS Updates Loaded': props<{ availableOsUpdates: MdmAvailableOsUpdate[] }>(),
    'Available OS Updates Loaded Error': props<{ error: ErrorModel }>(),
  },
});
